var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3867 8.94668C11.8667 9.46668 11.8667 10.3067 12.3867 10.8267L17.56 16L12.3867 21.1733C11.8667 21.6933 11.8667 22.5333 12.3867 23.0533C12.9067 23.5733 13.7467 23.5733 14.2667 23.0533L20.3867 16.9333C20.9067 16.4133 20.9067 15.5733 20.3867 15.0533L14.2667 8.93334C13.76 8.42668 12.9067 8.42668 12.3867 8.94668Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjM4NjcgOC45NDY2OEMxMS44NjY3IDkuNDY2NjggMTEuODY2NyAxMC4zMDY3IDEyLjM4NjcgMTAuODI2N0wxNy41NiAxNkwxMi4zODY3IDIxLjE3MzNDMTEuODY2NyAyMS42OTMzIDExLjg2NjcgMjIuNTMzMyAxMi4zODY3IDIzLjA1MzNDMTIuOTA2NyAyMy41NzMzIDEzLjc0NjcgMjMuNTczMyAxNC4yNjY3IDIzLjA1MzNMMjAuMzg2NyAxNi45MzMzQzIwLjkwNjcgMTYuNDEzMyAyMC45MDY3IDE1LjU3MzMgMjAuMzg2NyAxNS4wNTMzTDE0LjI2NjcgOC45MzMzNEMxMy43NiA4LjQyNjY4IDEyLjkwNjcgOC40MjY2OCAxMi4zODY3IDguOTQ2NjhaIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };